// resources
export const RESOURCES = {
  ORGA: '/v2/organizations',
  ORGA3: '/v3/organizations',
  V2: '/v2',
  V3: '/v3',
};

// methods
export const METHODS = {
  POST: 'post',
  GET: 'get',
  PUT: 'put',
  DELETE: 'delete',
};

// application type
export const APPLICATION_TYPE = {
  JSON: 'application/json',
  OCTET_STREAM: 'application/octet-stream',
  FORM_DATA: 'multipart/form-data',
};

export const ORG_TYPES_MAP = {
  FREE: 'Free trial',
  PAID: 'Pay as you go',
  ENTERPRISE: 'Enterprise',
  UNLIMITED: 'Unlimited',
  MANUAL: 'Manual',
  DELETED: 'Deleted',
  SUSPENDED: 'Suspended',
};

// under what conditions should the header become dark and sticky
export const HEADER_TRANSFORM = (props) =>
  !!(
    props.position.y > 200 ||
    (props.basePath !== '/' &&
      !props.basePath.includes('products') &&
      !props.basePath.includes('pricing') &&
      props.basePath !== '/contact' &&
      props.basePath !== '/documentation')
  );

export const HEADER_TRANSITION = (props) => props.basePath === '/';

export const REG_EX = {
  AT_LEAST_ONE_CHARACTER: '^\\s*\\S.*$',
  EMAIL: '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$',
  APP_AND_ORG_NAME_VALIDATOR: {
    EXP: '^(?=.*[a-zA-Z0-9])[a-zA-Z0-9-_+().,"/\'&\\[\\] ]{1,250}$',
    WARNING: `This field is required. Special characters limited to -_+()[]."/'&,`,
  },
};
